import { defineComponent as _defineComponent } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    name: null
  },
  setup(__props: any) {

const props = __props as {
  name: string;
}



return { __sfc: true,props }
}

})